import { createContext, useContext, ReactNode } from 'react';
import { useAuth, UserProfile, type TryFinishEmailLinkResult } from '@/hooks/useAuth';
import { User as FirebaseUser } from 'firebase/auth';

interface AuthContextType {
  user: FirebaseUser | null;
  profile: UserProfile | null;
  loading: boolean;
  error: Error | null;
  signInWithGoogle: () => Promise<void>;
  sendEmailSignInLink: (email: string) => Promise<void>;
  tryFinishEmailLinkSignIn: () => Promise<TryFinishEmailLinkResult>;
  finishEmailLinkSignInWithEmail: (email: string) => Promise<void>;
  signOut: () => Promise<void>;
  refreshProfile: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const auth = useAuth();

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthContext() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
}

// Re-export UserProfile type for convenience
export type { UserProfile, TryFinishEmailLinkResult };
